import { Button, ButtonGroup, Heading, Text, TextButton } from '@zillow/constellation-10';
import { useRentalManagerUser } from '@zg-rentals/rental-manager-env';

import LeaseModal from './Containers/LeaseModal';
import type { Lease } from '../models';
import { useLeasingUrlParams } from '../hooks/useLeasingUrlParams';
import { CANCEL } from '../constants/stringConstants';
import { emitDeleteDraftYesButtonEvent } from '../../analytics/events';
import { useArchiveLeaseMutation, useWebAnalyticsForListingQuery } from '../utils/queries';
import { LeaseArtifactType } from '@zg-rentals/ts-leasing-client';

type Props = {
  lease: Lease;
  onClose(): void;
};

function ArchiveLeaseModal({ lease, onClose }: Props): JSX.Element {
  const { user } = useRentalManagerUser();
  const { propertyId } = useLeasingUrlParams();
  const archiveMutation = useArchiveLeaseMutation();

  const webAnalyticsQuery = useWebAnalyticsForListingQuery(propertyId, { enabled: !!propertyId });
  const zrm_listing_info = webAnalyticsQuery.data;

  async function onArchiveLease() {
    await archiveMutation.mutateAsync({
      postData: { leaseArtifactType: LeaseArtifactType.LEASE, leaseArtifactId: lease.id as unknown as number },
    });
    emitDeleteDraftYesButtonEvent({ user, listing: zrm_listing_info });
    onClose();
  }

  return (
    <LeaseModal
      id="discard-changes"
      isOpen
      onClose={onClose}
      header={<Heading level={1}>Delete your draft?</Heading>}
      body={<Text>You won’t be able to view or restore the draft if you delete it.</Text>}
      footer={
        <ButtonGroup aria-label="delete draft">
          <TextButton tone="brand" onClick={onClose} disabled={archiveMutation.isPending}>
            {CANCEL}
          </TextButton>
          <Button tone="brand" emphasis="filled" onClick={onArchiveLease} loading={archiveMutation.isPending}>
            Yes
          </Button>
        </ButtonGroup>
      }
    />
  );
}

export default ArchiveLeaseModal;
